import React, { FC, useEffect, useState } from "react";
import { generatePath, useHistory, useLocation, useParams } from "react-router";
import {
  SearchOutlined,
  RightOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import AnalyticsComponent from "../AnalyticsComponent";
import { Badge, Col, Input, Progress, Row } from "antd";
import "./listChapterAnalytics.scss";
import { AnalyticsEmptyScreen } from "../EmptyScreen";
import { ChapterModel } from "../../../../../../../models/CourseModels/ChapterModel/chapter.model";
import { LIST_ANALYTICS_EXERCISES } from "../../../../../../../routes/routeConstants/appRoutes";
import AppHeader from "../../../../../../../shared/components/AppHeader";
const ListChapterAnalytics: FC = () => {
  const { state }: { state: any } = useLocation();
  const history = useHistory();
  const params = useParams();
  const [chapters, setChapters] = useState<ChapterModel[]>([]);
  const [selectedChapter, setSelectedChapter] = useState<ChapterModel>();
  const [showSearch, setSearchVisibility] = useState(false);
  const [studentChapterResult, setStudentChapterResult] = useState<any>({});
  useEffect(() => {
    fetchChapters({});
  }, []);
  useEffect(() => {
    //console.log(state);
  }, []);
  const fetchChapters = (params: any) => {};
  const fetchChapterAnalytics = (chapterId: any) => {};
  return (
    <div className="page-view">
      <AppHeader
      showBack
      headerText={state?.subjectName}
      showButton={false}
      showSearch={false}
      />
      <Row className="list__chapters">
        {chapters.length == 0 ? (
          <AnalyticsEmptyScreen title={"No chapters"} />
        ) : (
          <>
            <Col span={12} style={{ height: "100%" }}>
              <div className="content__left">
                {showSearch ? (
                  <div className="content-left__search">
                    <Input
                      className="content-left-search__input"
                      placeholder={"Search"}
                      prefix={<SearchOutlined />}
                      onChange={(e) => {
                        fetchChapters({ search: e.target.value });
                      }}
                    />
                    <CloseOutlined
                      className="content-left-search__icon"
                      onClick={() => setSearchVisibility(false)}
                    />
                  </div>
                ) : (
                  <div className="content-left__header">
                    <p>Chapters</p>
                    <div onClick={() => setSearchVisibility(true)}>
                      <SearchOutlined />
                    </div>
                  </div>
                )}
                {chapters?.map((value, index) => {
                  return (
                    <div
                      className={`subject__card ${
                        selectedChapter?.id == value.id &&
                        "subject-card__active"
                      }`}
                      onClick={() => {
                        setSelectedChapter(value);
                        fetchChapterAnalytics(value?.id);
                      }}
                    >
                      <p className="subject-card__name">{value?.name}</p>
                      <div className="subjects-details__container">
                        <p>
                          {/* {value?. || value?.examExercisesCount}{" "} */}
                          Chapters
                        </p>
                        <Badge status="default" className="dull-text" />
                        <div className="progress__wrapper">
                          <Progress showInfo={false} />
                          <p>0% Completed</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Col>
            <Col span={12} style={{ height: "100%" }}>
              <div className="content__right">
                <div className="content-right__header">
                  <p>{selectedChapter?.name}</p>
                  <div
                    className="content-right__btn"
                    onClick={() => {
                      history.push(
                        generatePath(LIST_ANALYTICS_EXERCISES, {
                          ...params,
                          chapterId: selectedChapter?.id,
                        }),
                        {
                          ...state,
                          chapterId: selectedChapter?.id,
                          chapterName: selectedChapter?.name,
                        }
                      );
                    }}
                  >
                    View by exercise{" "}
                    <span>
                      <RightOutlined />
                    </span>
                  </div>
                </div>
                <AnalyticsComponent
                  showAttempts={false}
                  accuracy={studentChapterResult?.accuracy}
                  contentLearnt={0}
                  exerciseAttempted={
                    studentChapterResult?.numberOfExerciseAttempts
                  }
                  speed={studentChapterResult?.averageTimePerQuestion}
                  score={studentChapterResult?.score}
                  duration={studentChapterResult?.averageTimePerQuestion}
                />
              </div>
            </Col>
          </>
        )}
      </Row>
    </div>
  );
};
export default ListChapterAnalytics;
